@if (Vendor && InsuranceAgent && ComplianceSetting && country) {
  <div class="add-coi-body">
    <header class="add-coi-head">
      <p class="add-coi-head__eyebrow">
        VIVE Vetting · Insurance review · {{ Vendor.legalName }}
      </p>
      <h2 class="add-coi-head__title">
        {{
          InsuranceCertificateFormGroup.controls['id'].value ? 'Edit' : 'Add'
        }}
        Certificate of Insurance
      </h2>
    </header>

    <form [formGroup]="InsuranceCertificateFormGroup" class="add-coi-card">
      <app-display-card>
        <dl class="cv-info add-coi-meta">
          <div class="cv-info__row">
            <dt>Vendor</dt>
            <dd>
              {{ Vendor.legalName }}
              <span class="cv-info__chip">ID {{ Vendor.id }}</span>
            </dd>
          </div>
          @if (Vendor.dba) {
            <div class="cv-info__row">
              <dt>DBA</dt>
              <dd>{{ Vendor.dba }}</dd>
            </div>
          }
          <div class="cv-info__row">
            <dt>Client</dt>
            <dd>
              {{ Company.legalName }}
              <span class="cv-info__chip">ID {{ Company.id }}</span>
            </dd>
          </div>
          <div class="cv-info__row">
            <dt>Vendor risk level</dt>
            <dd>{{ vendorRiskLevel === 0 ? 'Global' : vendorRiskLevel }}</dd>
          </div>
          <div class="cv-info__row">
            <dt>Agent</dt>
            <dd>
              {{ InsuranceAgent.firstName }} {{ InsuranceAgent.lastName }}
            </dd>
          </div>
          @if (InsuranceAgent.email) {
            <div class="cv-info__row">
              <dt>Agent email</dt>
              <dd>
                <a
                  class="add-coi-meta__email"
                  href="mailto:{{ InsuranceAgent.email }}"
                  >{{ InsuranceAgent.email }}</a
                >
              </dd>
            </div>
          }
          <div class="cv-info__row">
            <dt>Agent phone</dt>
            <dd>{{ InsuranceAgent.phone1 }}</dd>
          </div>
        </dl>

        <div class="add-coi-status">
          <div class="form-group mb-0 add-coi-status__field">
            <label class="form-label" for="coi-status">
              Certificate status
            </label>
            <select
              id="coi-status"
              class="form-select"
              formControlName="status"
            >
              @for (Status of InsuranceCertificateStatuses; track Status) {
                <option [value]="Status">{{ Status }}</option>
              }
            </select>
          </div>

          @if (AvailableInsurancePolicies.length > 0) {
            <div
              class="add-coi-status__policies"
              ngbDropdown
              [autoClose]="'outside'"
              container="body"
              placement="bottom-end"
            >
              <button type="button" class="btn btn-outline" ngbDropdownToggle>
                <i class="bi bi-plus-lg me-1"></i>
                Add policies
              </button>
              <div class="add-coi-policy-menu" ngbDropdownMenu>
                @for (item of AvailableInsurancePolicies; track item) {
                  @if (item && item[0]) {
                    <div class="form-check add-coi-policy-menu__item">
                      <input
                        id="policy-{{ item[1] }}"
                        type="checkbox"
                        class="form-check-input"
                        [checked]="
                          SelectedInsurancePolicyTypes.includes(item[0])
                        "
                        (change)="onPolicySelection(item[0])"
                      />
                      <label
                        for="policy-{{ item[1] }}"
                        class="form-check-label"
                      >
                        {{ item[1] }}
                      </label>
                    </div>
                  }
                }
                <div class="add-coi-policy-menu__footer">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm w-100"
                    (click)="addInsurancePolicies()"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </app-display-card>
    </form>
    <div class="add-coi-files">
      <app-display-card [justifyContent]="'start'">
        <header class="add-coi-section-head">
          <h3 class="mb-0">COI file</h3>
          <p class="add-coi-section-sub mb-0">Primary certificate document.</p>
        </header>
        <app-file-upload-file-display
          [layout]="'vertical'"
          [displayNoScanButton]="false"
          [fileInfoDisplayType]="'minimal'"
          [hideSelectFileButton]="true"
          [removeFileButtonText]="'Remove'"
          [Files]="getFilesFromCompanyVendorFiles(COIFiles)"
          (FileEvent)="fileUpload($event, 'COI')"
          (removeFileEvent)="removeFile($event, 'COI')"
          (downloadFileEvent)="downloadFile($event)"
        ></app-file-upload-file-display>
      </app-display-card>

      <app-display-card [justifyContent]="'start'">
        <header class="add-coi-section-head">
          <h3 class="mb-0">Supporting files</h3>
          <p class="add-coi-section-sub mb-0">
            Endorsements, schedules, or any other backup.
          </p>
        </header>
        <app-file-upload-file-display
          [layout]="'vertical'"
          [fileInfoDisplayType]="'minimal'"
          [hideSelectFileButton]="true"
          [removeFileButtonText]="'Remove'"
          [Files]="getFilesFromCompanyVendorFiles(SupportingFiles)"
          (FileEvent)="fileUpload($event, 'Supporting File')"
          (removeFileEvent)="removeFile($event, 'Supporting File')"
        ></app-file-upload-file-display>
      </app-display-card>
    </div>
    <div class="add-coi-parties">
      <form [formGroup]="InsuranceCertificateFormGroup" class="add-coi-card">
        <app-display-card>
          <header class="add-coi-section-head add-coi-section-head--split">
            <div>
              <h3 class="mb-0">Producer</h3>
              <p class="add-coi-section-sub mb-0">
                The agency that issued the COI.
              </p>
            </div>
          </header>

          <div class="row g-3">
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-prodName">Name</label>
                <input
                  id="coi-prodName"
                  type="text"
                  class="form-control"
                  formControlName="prodName"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-prodAddress">Street</label>
                <input
                  id="coi-prodAddress"
                  type="text"
                  class="form-control"
                  formControlName="prodAddress"
                />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-prodCity">City</label>
                <input
                  id="coi-prodCity"
                  type="text"
                  class="form-control"
                  formControlName="prodCity"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-prodState">State</label>
                <select
                  id="coi-prodState"
                  class="form-select"
                  formControlName="prodState"
                >
                  @for (
                    SubNationalDivision of SubNationalDivisions;
                    track SubNationalDivision
                  ) {
                    <option [ngValue]="SubNationalDivision.abbreviation">
                      {{ SubNationalDivision.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-prodZip">ZIP</label>
                <input
                  id="coi-prodZip"
                  type="text"
                  class="form-control"
                  formControlName="prodZip"
                />
              </div>
            </div>
          </div>

          <hr class="add-coi-divider" />

          <header class="add-coi-section-head add-coi-section-head--split">
            <div>
              <h3 class="mb-0">Insured contact</h3>
              <p class="add-coi-section-sub mb-0">
                Where notices for this policy should be sent.
              </p>
            </div>
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="copyAgentContactInfo()"
            >
              <i class="bi bi-clipboard me-1"></i>
              Copy from agent
            </button>
          </header>

          <div class="row g-3">
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label class="form-label" requiredAsterisk for="coi-contactName"
                  >Name</label
                >
                <input
                  id="coi-contactName"
                  type="text"
                  class="form-control"
                  formControlName="contactName"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-contactAddress">
                  Street
                </label>
                <input
                  id="coi-contactAddress"
                  type="text"
                  class="form-control"
                  formControlName="contactAddress"
                />
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-contactCity">City</label>
                <input
                  id="coi-contactCity"
                  type="text"
                  class="form-control"
                  formControlName="contactCity"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-contactState">State</label>
                <select
                  id="coi-contactState"
                  class="form-select"
                  formControlName="contactState"
                >
                  @for (
                    SubNationalDivision of SubNationalDivisions;
                    track SubNationalDivision
                  ) {
                    <option [ngValue]="SubNationalDivision.abbreviation">
                      {{ SubNationalDivision.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label class="form-label" for="coi-contactZip">ZIP</label>
                <input
                  id="coi-contactZip"
                  type="text"
                  class="form-control"
                  formControlName="contactZip"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label
                  class="form-label"
                  requiredAsterisk
                  for="coi-contactPhone"
                  >Phone</label
                >
                <input
                  id="coi-contactPhone"
                  type="text"
                  class="form-control"
                  formControlName="contactPhone"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label
                  class="form-label"
                  requiredAsterisk
                  for="coi-contactEmail"
                  >Email</label
                >
                <input
                  id="coi-contactEmail"
                  type="text"
                  class="form-control"
                  formControlName="contactEmail"
                />
              </div>
            </div>
          </div>
        </app-display-card>
      </form>

      <app-display-card>
        <header class="add-coi-section-head add-coi-section-head--split">
          <div>
            <h3 class="mb-0">Insurers (A.M. Best)</h3>
            <p class="add-coi-section-sub mb-0">
              Look up NAIC numbers to auto-fill the rating columns.
            </p>
          </div>
          <button
            type="button"
            class="btn btn-outline btn-sm"
            (click)="AMBestLookup()"
          >
            <i class="bi bi-box-arrow-up-right me-1"></i>
            A.M. Best lookup
          </button>
        </header>

        <div class="add-coi-insurer-table">
          <div class="add-coi-insurer-table__head">
            <div></div>
            <div>NAIC #</div>
            <div>Name</div>
            <div>A.M. Best #</div>
            <div>Rating</div>
            <div>Size</div>
          </div>
          @for (InsurerObject of Insurers | keyvalue; track InsurerObject) {
            <div class="add-coi-insurer-table__row">
              <div class="add-coi-insurer-table__label">
                Insurer {{ InsurerObject.value.letter }}
              </div>
              <input
                type="number"
                class="form-control"
                (change)="
                  performLookup(
                    InsurerObject.key,
                    InsurerObject.value
                  ).subscribe()
                "
                maxlength="6"
                [(ngModel)]="InsurerObject.value.naic"
              />
              <input
                type="text"
                class="form-control"
                (ngModelChange)="
                  insurerNameChanged(InsurerObject.value, $event)
                "
                [ngModel]="InsurerObject.value.name"
              />
              <input
                type="number"
                class="form-control"
                (ngModelChange)="
                  insurerInformationChanged(
                    InsurerObject.value,
                    $event,
                    'aMBestCompanyNumber'
                  )
                "
                [(ngModel)]="InsurerObject.value.amBestNumber"
              />
              <select
                class="form-select"
                (ngModelChange)="
                  insurerInformationChanged(
                    InsurerObject.value,
                    $event,
                    'amBestRating'
                  )
                "
                [(ngModel)]="InsurerObject.value.amBestRating"
              >
                @for (
                  AMBestRating of AMBestRatings | keyvalue;
                  track AMBestRating
                ) {
                  <option [ngValue]="AMBestRating.value">
                    {{ AMBestRating.key }}
                  </option>
                }
              </select>
              <select
                class="form-select"
                (ngModelChange)="
                  insurerInformationChanged(
                    InsurerObject.value,
                    $event,
                    'financialSize'
                  )
                "
                [(ngModel)]="InsurerObject.value.sizeCategory"
              >
                @for (SizeCategory of SizeCategories; track SizeCategory) {
                  <option>
                    {{ SizeCategory }}
                  </option>
                }
              </select>
            </div>
          }
        </div>
      </app-display-card>
    </div>
    @for (
      PolicyFormGroup of insurancePolicyFormSort(
        InsuranceCertificateFormGroup.controls['InsurancePolicies'].controls
      );
      track PolicyFormGroup;
      let index = $index
    ) {
      <form class="add-coi-policy" [formGroup]="PolicyFormGroup">
        <app-display-card>
          <header class="add-coi-policy__head">
            <div class="add-coi-policy__title">
              @if (PolicyFormGroup.controls['policyType'].value) {
                <h3 class="mb-0">
                  {{
                    PolicyTypeToLabelMap.get(
                      PolicyFormGroup.controls['policyType'].value
                    )
                  }}
                </h3>
              }
              @if (isPolicyRequiredByClient(PolicyFormGroup)) {
                <span class="chip chip-error">Required</span>
              }
              <span class="chip chip-host" appStatusStyleChanges>
                {{ PolicyFormGroup.controls['status'].value }}
              </span>
            </div>
            @if (PolicyFormGroup.controls['status'].value !== 'Cancelled') {
              <button
                type="button"
                class="btn btn-outline btn-sm"
                (click)="cancelPolicy(PolicyFormGroup, index)"
              >
                <i class="bi bi-x-octagon me-1"></i>
                Cancel policy
              </button>
            }
          </header>
          <div class="add-coi-policy-fields">
            <div class="row row-padding">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <label class="form-label"
                      >Insurer
                      @if (
                        isPolicyRequiredAndManagedByAgent(PolicyFormGroup) &&
                        country === 'US'
                      ) {
                        <span class="required-field-asterisk">*</span>
                      }
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <select
                      class="form-select"
                      formControlName="insurerLetter"
                      (ngModelChange)="
                        setPolicyInsurer(PolicyFormGroup, $event)
                      "
                    >
                      @for (Insurer of AvailableInsurers; track Insurer) {
                        <option [ngValue]="Insurer.letter">
                          {{ Insurer.letter }}: {{ Insurer.name }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <label
                      >Policy Number
                      @if (isPolicyRequiredAndManagedByAgent(PolicyFormGroup)) {
                        <span class="required-field-asterisk">*</span>
                      }
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="policyNumber"
                      [inputMask]="alphanumericMask"
                      maxlength="45"
                    />
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <label
                      >Effective Date
                      @if (isPolicyRequiredAndManagedByAgent(PolicyFormGroup)) {
                        <span class="required-field-asterisk">*</span>
                      }
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="input-group">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="MM/DD/YYYY"
                        formControlName="effectiveDate"
                        [minDate]="minDatePickerDate"
                        navigation="select"
                        ngbDatepicker
                        container="body"
                        #effectiveDatePicker="ngbDatepicker"
                        appNgbDateInputMask
                      />
                      <button
                        class="btn btn-primary datepicker-button btn-outline-secondary bi bi-calendar"
                        (click)="effectiveDatePicker.toggle()"
                        type="button"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col">
                    <label
                      >Expiration Date
                      @if (isPolicyRequiredAndManagedByAgent(PolicyFormGroup)) {
                        <span class="required-field-asterisk">*</span>
                      }
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="input-group">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="MM/DD/YYYY"
                        formControlName="expirationDate"
                        [minDate]="minDatePickerDate"
                        navigation="select"
                        ngbDatepicker
                        container="body"
                        #expirationDatePicker="ngbDatepicker"
                        appNgbDateInputMask
                      />
                      <button
                        class="btn btn-primary datepicker-button btn-outline-secondary bi bi-calendar"
                        (click)="expirationDatePicker.toggle()"
                        type="button"
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            @if (PolicyFormGroup.controls['policyType'].value === 'GL') {
              <div class="row row-padding">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label
                        >Each Occurrence
                        @if (
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['perOccurence'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['perOccurence']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label>Damage To Rented Premises</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['damageToRented'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['damageToRented']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label>Medical Expenses</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['medicalExpenses'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['medicalExpenses']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label>Personal & Adv Injury</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['personalAdvInjury'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['personalAdvInjury']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'GL') {
              <div class="row row-padding">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label
                        >General Aggregate
                        @if (
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['aggregate'],
                              $event
                            )
                          "
                          [formControl]="PolicyFormGroup.controls['aggregate']"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label>Prod-Comp / Op Aggregate</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['productOps'],
                              $event
                            )
                          "
                          [formControl]="PolicyFormGroup.controls['productOps']"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label>Pollution Liability Coverage</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['pollution'],
                              $event
                            )
                          "
                          [formControl]="PolicyFormGroup.controls['pollution']"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label>GarageKeeper's Policy Amount</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['garageKeepers'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['garageKeepers']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'GL') {
              <div class="row row-padding">
                <!--
                                                              <div class="col">
                                                                <div class="row">
                                                                  <div class="col">
                                                                    <label>HNO Auto Coverage</label>
                                                                  </div>
                                                                </div>
                                                                <div class="row">
                                                                  <div class="col">
                                                                    <div class="input-group">
                                                                      <span class="input-group-text">$</span>
                                                                      <input type="text" class="form-control" [inputMask]="currencyMask" placeholder="" (ngModelChange)="applyCurrencyFormat(PolicyFormGroup.controls['nonOwnedAutoAmount'], $event)" [formControl]="PolicyFormGroup.controls['nonOwnedAutoAmount']"/>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              -->
                @if (Company && Company.country === 'CA') {
                  <div class="col">
                    <div class="row">
                      <div class="col">
                        <label>Hired Autos</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="input-group">
                          <span class="input-group-text">$</span>
                          <input
                            type="text"
                            class="form-control"
                            [inputMask]="currencyMask"
                            placeholder=""
                            (ngModelChange)="
                              applyCurrencyFormat(
                                PolicyFormGroup.controls['hiredAutos'],
                                $event
                              )
                            "
                            [formControl]="
                              PolicyFormGroup.controls['hiredAutos']
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row">
                      <div class="col">
                        <label>Non-Owned Autos</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="input-group">
                          <span class="input-group-text">$</span>
                          <input
                            type="text"
                            class="form-control"
                            [inputMask]="currencyMask"
                            placeholder=""
                            (ngModelChange)="
                              applyCurrencyFormat(
                                PolicyFormGroup.controls['nonOwnedAutos'],
                                $event
                              )
                            "
                            [formControl]="
                              PolicyFormGroup.controls['nonOwnedAutos']
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Occurrence based?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="isPerOccurrence"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'GL') {
              <div class="row row-padding">
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Valid Desc. of Operations?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasDescOps"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Additional Insured?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="addlInsured"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has A.I. Ongoing Ops?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasAiOngoingOps"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'GL') {
              <div class="row row-padding">
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has A.I. Comp. Ops?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasAiCompOps"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Primary & Non-Contributory (PNC)?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasPnc"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Waiver of Subrogation?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="subrWvd"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'GL') {
              <div class="row row-padding">
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has Required Forms?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasRequiredForms"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Contractual Liability?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="isContractualLiability"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Per Proj/Loc Agg?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="perProjLocAgg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has Full Policy?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasPolicyDoc"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'GL') {
              <div class="row row-padding">
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >COI Name/Legal Name Mismatch?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="legalNameMismatch"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                @if (Company.allowAdditionalInsuredEndorsements) {
                  <div class="col-auto d-flex flex-column justify-content-end">
                    <div class="row">
                      <div class="col">
                        <div class="form-check">
                          <label class="form-check-label my-0"
                            >Additional Insured Endorsement-Scheduled
                            Names?</label
                          >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControlName="hasAdditionalInsuredEndorsements"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (
                  PolicyFormGroup.controls['hasAdditionalInsuredEndorsements']
                    .value && Company.allowAdditionalInsuredEndorsements
                ) {
                  <div class="col-3">
                    <button
                      class="btn btn-primary"
                      (click)="selectPolicySites(PolicyFormGroup)"
                    >
                      Select sites
                    </button>
                  </div>
                }
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'AUTO') {
              <div class="row row-padding">
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Split Limit Policy?</label
                        >
                        <input
                          class="form-check-input"
                          (ngModelChange)="splitLimitPolicyChange($event)"
                          type="checkbox"
                          formControlName="isCaSplitLimit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Is Commercial Policy?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="isCommercialAuto"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has Full Policy?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasPolicyDoc"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Valid Desc. of Operations?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasDescOps"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'AUTO') {
              <div class="row row-padding">
                <div class="col-auto">
                  <div class="row">
                    <div class="col">
                      <label
                        >Combined Single Limit
                        @if (
                          !PolicyFormGroup.controls['isCaSplitLimit'].value &&
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['combinedSingle'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['combinedSingle']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col d-flex flex-column justify-content-center align-items-center"
                >
                  <label>OR</label>
                </div>
                <div class="col-auto">
                  <div class="row">
                    <div class="col">
                      <label
                        >Bodily Injury (Per Person)
                        @if (
                          PolicyFormGroup.controls['isCaSplitLimit'].value &&
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['biPerPerson'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['biPerPerson']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="row">
                    <div class="col">
                      <label
                        >Bodily Injury (Per Accident)
                        @if (
                          PolicyFormGroup.controls['isCaSplitLimit'].value &&
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['biPerAccident'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['biPerAccident']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="row">
                    <div class="col">
                      <label
                        >Property Damage Limit
                        @if (
                          PolicyFormGroup.controls['isCaSplitLimit'].value &&
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['propertyDamage'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['propertyDamage']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'AUTO') {
              <div class="row row-padding">
                <div class="col-3">
                  <div class="row">
                    <div class="col">
                      <label>On-Hook Towing Amount</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['onHookTowing'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['onHookTowing']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Additional Insured</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="addlInsured"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Waiver of Subrogation</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="subrWvd"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has Required Forms?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasRequiredForms"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'AUTO') {
              <div class="row row-padding">
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Hired & Non-Owned Autos?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasNonOwnedAuto"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                @if (Company.allowAdditionalInsuredEndorsements) {
                  <div class="col-auto d-flex flex-column justify-content-end">
                    <div class="row">
                      <div class="col">
                        <div class="form-check">
                          <label class="form-check-label my-0"
                            >Additional Insured Endorsement-Scheduled
                            Names?</label
                          >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControlName="hasAdditionalInsuredEndorsements"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (
                  PolicyFormGroup.controls['hasAdditionalInsuredEndorsements']
                    .value
                ) {
                  <div class="col-3">
                    <button
                      class="btn btn-primary"
                      (click)="selectPolicySites(PolicyFormGroup)"
                    >
                      Select sites
                    </button>
                  </div>
                }
              </div>
            }
            @if (
              PolicyFormGroup.controls['policyType'].value === 'AUTO' &&
              ComplianceSetting.CompanyComplianceType!.type === 'transporter'
            ) {
              <div class="row row-padding">
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Contingent Auto</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="contingentAuto"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="row">
                    <div class="col">
                      <label>Trailer Interchange</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['trailerInterchange'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['trailerInterchange']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="row">
                    <div class="col">
                      <label>Cargo Liability</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['cargoLiability'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['cargoLiability']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'AUTO') {
              <div class="row row-padding">
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >COI Name/Legal Name Mismatch?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="legalNameMismatch"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'UMB') {
              <div class="row row-padding">
                <div class="col-3">
                  <div class="row">
                    <div class="col">
                      <label
                        >Each Occurrence
                        @if (
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['perOccurence'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['perOccurence']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="row">
                    <div class="col">
                      <label>Aggregate</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['aggregate'],
                              $event
                            )
                          "
                          [formControl]="PolicyFormGroup.controls['aggregate']"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Additional Insured?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="addlInsured"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Waiver of Subrogation?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="subrWvd"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'UMB') {
              <div class="row row-padding">
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has Required Forms?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasRequiredForms"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has Full Policy?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasPolicyDoc"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Valid Desc. of Operations?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasDescOps"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Occurrence Based?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="occurrenceBased"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'UMB') {
              <div class="row row-padding">
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Primary & Non-Contributory (PNC)?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasPnc"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >COI Name/Legal Name Mismatch?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="legalNameMismatch"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'WC') {
              <div class="row row-padding">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label
                        >E.L. Each Accident
                        @if (
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['elEachAccident'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['elEachAccident']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label
                        >E.L Disease Each Employee
                        @if (
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['elDiseaseEachEmployee'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['elDiseaseEachEmployee']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <label
                        >E.L Disease Policy Limit
                        @if (
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['elDiseasePerPolicy'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['elDiseasePerPolicy']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Waiver of Subrogation?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="subrWvd"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'WC') {
              <div class="row row-padding">
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Has Required Forms?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasRequiredForms"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Valid Desc. of Operations?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasDescOps"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Officer Exclusion?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="officerExcluded"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >COI Name/Legal Name Mismatch?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="legalNameMismatch"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (PolicyFormGroup.controls['policyType'].value === 'PL') {
              <div class="row row-padding">
                <div class="col-3">
                  <div class="row">
                    <div class="col">
                      <label
                        >Each Occurrence
                        @if (
                          isPolicyRequiredAndManagedByAgent(PolicyFormGroup)
                        ) {
                          <span class="required-field-asterisk">*</span>
                        }
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['perOccurence'],
                              $event
                            )
                          "
                          [formControl]="
                            PolicyFormGroup.controls['perOccurence']
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="row">
                    <div class="col">
                      <label>Aggregate</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          [inputMask]="currencyMask"
                          placeholder=""
                          (ngModelChange)="
                            applyCurrencyFormat(
                              PolicyFormGroup.controls['aggregate'],
                              $event
                            )
                          "
                          [formControl]="PolicyFormGroup.controls['aggregate']"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >Valid Desc. of Operations</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="hasDescOps"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col d-flex flex-column justify-content-end">
                  <div class="row">
                    <div class="col">
                      <div class="form-check">
                        <label class="form-check-label my-0"
                          >COI Name/Legal Name Mismatch?</label
                        >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          formControlName="legalNameMismatch"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </app-display-card>
      </form>
    }

    <form [formGroup]="InsuranceCertificateFormGroup" class="add-coi-card">
      <app-display-card>
        <header class="add-coi-section-head">
          <h3 class="mb-0">Certificate validation</h3>
          <p class="add-coi-section-sub mb-0">
            Confirm the certificate's named holder and signature line.
          </p>
        </header>
        <div class="add-coi-validation">
          <div class="form-check">
            <input
              id="viveNamedCertHolder"
              class="form-check-input"
              type="checkbox"
              formControlName="viveNamedCertHolder"
            />
            <label for="viveNamedCertHolder" class="form-check-label">
              VIVE named as certificate holder
            </label>
          </div>
          <div class="form-check">
            <input
              id="agentSigned"
              class="form-check-input"
              type="checkbox"
              formControlName="agentSigned"
            />
            <label for="agentSigned" class="form-check-label">
              Agent signed
            </label>
          </div>
        </div>
      </app-display-card>
    </form>

    <div class="add-coi-footer">
      <div class="action-row justify-end">
        <button type="button" class="btn btn-ghost" (click)="cancel()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          Save COI
        </button>
      </div>
    </div>
  </div>
}
